import React, { useState } from 'react';
import { Table } from '@ajaibid/components';

import { styTable, styWrapper } from './style';
import useOrderMF from './hooks/useOrderMF';
import useMFOrderColumns from './hooks/useMFOrderColumns';
import ExpandableMFDetail from '../component/expandable';
import ModalStatusMF from '../component/ModalStatus';
import ModalUploadPayment from './component/ModalUploadPayment';

function getRowId(row, ix, parent) {
  return `${parent ? `${parent?.id}__` : ''}${row?.order_no || ix}`;
}

function renderRowExpand(row) {
  return <ExpandableMFDetail item={row.original} source="Order" />;
}

const MutualFundOrder = () => {
  const { data, fetchNextPage, isInitialLoading, isFetchingNextPage } = useOrderMF();
  const [modal, setModal] = useState(null);
  const [isModalUpload, setIsModalUpload] = useState(false);
  const [transactionId, setTransactionId] = useState('');
  const columns = useMFOrderColumns(setModal, setIsModalUpload, setTransactionId);
  const showModal = !!modal;
  const closeModal = () => setModal(null);

  return (
    <div className={styWrapper}>
      <Table
        className={styTable}
        data={data}
        columns={columns}
        options={{ isHeaderVisible: true, isRowExpandable: true }}
        fetchNext={fetchNextPage}
        getRowId={getRowId}
        isInitialLoading={isInitialLoading}
        isFetchingNext={isFetchingNextPage}
        renderRowExpand={renderRowExpand}
        emptyStateContent="Mulai bertransaksi dan lihat statusnya di sini."
      />
      <ModalStatusMF show={showModal} onClose={closeModal} item={modal} />
      <ModalUploadPayment
        isModalUpload={isModalUpload}
        setIsModalUpload={setIsModalUpload}
        transactionId={transactionId}
      />
    </div>
  );
};

export default MutualFundOrder;
